<script lang="ts">
    import { _ } from "svelte-i18n"
    import { fade } from "svelte/transition"
    import { lineData } from "../../codes"
    import { checkoutData, login, location } from "../../store"
    import { firstProductImage, getProductPrice } from "../../utils"
    import { navigate } from "../../../../vendor/svelte-routing"
    import { formatPriceCurrency, langField } from "../../i18n"

    import ProductAvailabilityStatus from "../widgets/ProductAvailabilityStatus.svelte"
    import CustomerRatingsLine from "./CustomerRatingsLine.svelte"

    export let product: Product

    $: detailsHref =
        ($location.path && $location.path != "/" ? $location.path + "/" : "") +
        product.code +
        "_" +
        langField(product.slug, "")
</script>

<div
    class="product"
    role="link"
    tabindex="0"
    in:fade="{{}}"
    on:click="{() => {
        navigate(detailsHref)
    }}"
    on:keydown
>
    <div class="image">
        <picture>
            <source srcset="{firstProductImage(product, 's')}" media="(max-width: 550px)" />
            <source srcset="{firstProductImage(product, 'm')}" media="(max-width: 768px)" />
            <img src="{firstProductImage(product, 'l')}" alt="{langField(product.name, '')}" />
        </picture>
    </div>
    <div class="text">
        <div class="infos">
            <CustomerRatingsLine {product} />

            <div class="line">
                <div class="nr">
                    {$_("product.item-number-short")}
                    {product.code}
                </div>
            </div>
            <div class="line">
                <div class="title">
                    <a href="{detailsHref}" on:click|preventDefault="{() => false}">{langField(product.name, "")}</a>
                </div>
            </div>
            {#if product.delivery_time}
                <div class="line">
                    {#if product.config_params?.line_code}
                        <div></div>
                    {/if}
                    <ProductAvailabilityStatus {product} />
                </div>
            {/if}
            <div class="line">
                {#if product.config_params?.line_code}
                    <div class="cat {lineData(product.config_params.line_code).class}">
                        {lineData(product.config_params.line_code).text}
                    </div>
                {/if}

                <div class="price">
                    {$formatPriceCurrency(
                        getProductPrice(product, null, null, !!$login),
                        $login ? 0 : $checkoutData.vat
                    )}
                </div>
            </div>
        </div>
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";
    .product {
        cursor: pointer;
        .flex();
        flex-direction: column;
        .transition();
        padding: 20px;
        position: relative;
        background-color: var(--comp--product--background);
        color: var(--comp--product--color);

        a {
            // position: absolute;
            // top: 0;
            // bottom: 0;
            // left: 0;
            // right: 0;
            color: var(--comp--product--color);
        }
        .image {
            width: 100%;
            height: 45vw;
            margin-bottom: 10px;
            .flex();
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: var(--surface);
            @media @tablet {
                height: 15vw;
            }
            picture {
                width: 100%;
                height: 100%;
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .text {
            flex-grow: 1;
            .flex();
            flex-direction: column;
            justify-content: space-between;
            .infos {
                .flex();
                flex-direction: column;
                justify-content: space-between;
                flex-grow: 1;

                .line {
                    .flex();
                    justify-content: space-between;
                    align-items: center;

                    .price {
                        background-color: var(--comp--product--price--background);
                        color: var(--comp--product--price--color);
                        border-radius: var(--comp--product--price--border-radius);
                        padding: var(--comp--product--price--padding);
                    }
                    .nr {
                        font-size: 0.6rem;
                    }

                    .cat {
                        font-size: 0.7rem;
                        background: var(--secondary);
                        color: var(--on-secondary);
                        line-height: 1;
                        padding: 5px 8px;
                        &.premium {
                            background: var(--surface-3);
                            color: var(--on-surface-3);
                        }
                        &.exclusive {
                            background: var(--primary);
                            color: var(--on-primary);
                        }
                    }
                    .title {
                        line-height: 1.2;
                        margin-bottom: 10px;
                    }
                    &:nth-of-type(1) {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                }
            }
        }
        @media @desktop {
            &:hover {
                background-color: var(--comp--product--background-hover);
            }
        }
    }
</style>
